import {Component, Input, OnInit} from '@angular/core';
import {SharedServiceService} from '../../../../core/services/shared-service.service';
import {ApiService} from '../../../../core/http/api.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-organizations-list',
    templateUrl: './organizations-list.component.html',
    styleUrls: ['./organizations-list.component.css'],
    standalone: false
})
export class OrganizationsListComponent implements OnInit {

  loaders = Array(10).fill(0);

  @Input() organizations: any[] = [];
  @Input() loading = false;
  @Input() organizationPerPage = 10;
  @Input() organizationPage = 1;
  @Input() organizationTotal = 0;
  @Input() modalRef;
  @Input() selectedOrganization: any = {};


  constructor(
    private shared: SharedServiceService,
    private api: ApiService,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit(): void {
  }

  pageChange(event): void {
    this.shared.dispatchEmitter('organizationPage', {event});
  }

  showModal(event, type = '', data = {}): void {
    this.shared.dispatchEmitter('organizationModal', {event, type, data});
  }

  remove(id: string): void {
    if (confirm('Do you want to delete this organization?')) {
      this.api.deleteOrganization(id).subscribe(res => {
        this.toastr.success('Organization deleted successfully!');
        this.shared.dispatchEmitter('organization', {});
      });
    }
  }

  closeModal(): void {
    this.shared.dispatchEmitter('closeModal', {});
  }

}
